[
  {
    "name": "$email",
    "displayName": "Email",
    "description": "The user's email address.",
    "type": "string",
    "exampleValue": "xyz@lmnop.com"
  },
  {
    "name": "$first_name",
    "displayName": "First Name",
    "description": "The first name of the user.",
    "type": "string",
    "exampleValue": "Scott"
  },
  {
    "name": "$last_name",
    "displayName": "Last Name",
    "description": "The last name of the user.",
    "type": "string",
    "exampleValue": "Johnson"
  },
  {
    "name": "$name",
    "displayName": "Name",
    "description": "The full name of the user.",
    "type": "string",
    "exampleValue": "Nicole Johnson"
  },
  {
    "name": "$avatar",
    "displayName": "Avatar URL",
    "description": "URL resource of a gif, jpg, jpeg, or png to update the profile picture in a profile. This property will override a profile picture pulled from Gravatar.",
    "type": "string"
  },
  {
    "name": "$ip",
    "displayName": "IP",
    "description": "The IP address of a user. Used to infer geographical information."
  },
  {
    "name": "$phone",
    "displayName": "Phone",
    "description": "The user's phone number. Note that a '+' needs to precede phone numbers. This is especially useful for international numbers.",
    "type": "number",
    "exampleValue": "+1 555 123 4567"
  }
]
